module.exports = __webpack_public_path__ + "img/alarm.51169fa8.svg";